import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { JOBS_SUB_MENU } from "@constants";
import { TabMenu } from "../../../components";
import { AssignmentAudit, InstantPayAudit } from "./components";

import "./Audit.scss";

class Audit extends Component {
	constructor(props) {
		super(props);
		const { user, router } = props;
		if (!user?.isSuperAdmin()) router.push("/");

		this.state = {};
	}

	onClickTab = ({ tabNumber, url }) => {
		const { router } = this.props;
		const thisTab = JOBS_SUB_MENU.find(tab => tab.type === "audit");
		if (tabNumber !== thisTab.tabNumber) router.push(url);
	};

	render() {
		const { user } = this.props;

		return (
			<Fragment>
				<TabMenu
					tabs={JOBS_SUB_MENU}
					activeTab={JOBS_SUB_MENU.find(tab => tab.type === "audit").tabNumber}
					onClickTab={this.onClickTab}
					user={user}
				/>
				<div
					id="audit"
					className="container"
				>
					<AssignmentAudit />
					<InstantPayAudit />
				</div>
			</Fragment>
		);
	}
}

Audit.propTypes = {
	user: PropTypes.object,
	router: PropTypes.object,
};

Audit.defaultProps = {
	user: {},
	router: {},
};

export default Audit;
